import {
  Box,
  Grid,
  Typography,
  Card,
  CardMedia,
  IconButton,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  InputAdornment,
  Checkbox,
  ListItemText,
  InputLabel,
  Select,
  FormControl,
  FormHelperText,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Salon_img from "../../assets/img/details_img.png";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Footer from "../../common/Footer";
import profile_login from "../../assets/img/profile_login_img.png";
import otp_login from "../../assets/img/otp_login.png";
import { routePath } from "../../constants/routePath";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import axios from "axios";
import Swal from "sweetalert2";
import { TimeModal } from "../appoinmentModal/TimeModal";
import EmployeeModal from "../../common/employeeModel";
import { getAlldetailSerice } from "../services/servicesListApi";
import SEO from "../../common/SEO";
const services = [
  "Haircut",
  "Hair Coloring",
  "Hair Styling",
  "Manicure",
  "Pedicure",
];

const Appoinment = () => {
  const infoD = useSelector((state) => state.reducer.detail);
  const [servicesArr, setServicesArr] = useState([]);

  const details = useSelector((state) => state.reducer.detail);
  const [openTt, setOpenTt] = useState(false);

  useEffect(() => {
    console.log(infoD, "detailsssssssssPage");
  }, [infoD]);

  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [openOtpDialog, setOpenOtpDialog] = useState(false);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [bookingMode, setBookingMode] = useState("profile_login");
  const [otp, setOtp] = useState(["", "", "", ""]);

  const smbToken = sessionStorage.getItem("smbToken");
  useEffect(() => {
    setBookingMode(smbToken ? "profile_login" : "otp");
  }, []);
  const handleOpenProfileDialog = (mode) => {
    setBookingMode(mode);
    setOpenProfileDialog(true);
  };
  useEffect(() => {
    getAlldetailSerice({ billerId: infoD?.billerId }, (res) => {
      setServicesArr(res?.data);
      console.log("services", res?.data);
    });
  }, []);

  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    service: [],
    gender: "Male",
    date: "",
    hour: "",
    minute: "",
  });

  const handleServiceChange = (event) => {
    const {
      target: { value },
    } = event;
    setForm((prev) => ({
      ...prev,
      service: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const [errors, setErrors] = useState({});
  const [openOtpSuccessModal, setOpenOtpSuccessModal] = useState(false);

  const [timeModalOpen, setTimeModalOpen] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Full Name is required";
    }

    if (!form.mobile.trim()) {
      newErrors.mobile = "Mobile Number is required";
    } else if (!/^\d{10}$/.test(form.mobile.trim())) {
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    }

    if (!form.service || form.service.length === 0) {
      newErrors.service = "At least one service is required";
    }

    if (!date) {
      newErrors.date = "Date is required";
    }

    if (!form.hour || !form.minute) {
      newErrors.time = "Start time is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (field) => (event) => {
    setForm({ ...form, [field]: event.target.value });
  };

  function formatTimeTo12Hour(hour24, minute) {
    if (
      hour24 === undefined ||
      minute === undefined ||
      hour24 === null ||
      minute === null
    ) {
      return "";
    }
    const hour = hour24 % 12 || 12;
    const min = minute.toString().padStart(2, "0");
    const noon = hour24 >= 12 ? "PM" : "AM";
    return `${hour} : ${min} ${noon}`;
  }
  const handleSubmit = async () => {
    if (!validate()) return;

    const payload = {
      billerId: infoD?.billerId,
      customerName: form.name,
      mobileNumber: form.mobile,
      mailId: form.email,
      services: form.service.map((ele) => ({ service: ele.itemCategoryName })), // ✅ FIXED
      gender: form.gender,
      date: date?.toISOString().split("T")[0],
      hour: form.hour,
      minute: form.minute,
      status: "unassigned",
    };

    const loginApi =
      "https://elegantprime.in/webapp/user/api/v1/Salon/AddCustomerAppointmentForBuyer";
    const otpApi =
      "https://elegantprime.in/webapp/user/api/v1/Salon/AddCustomerAppointmentForAnonymousBuyer";

    const smbToken = sessionStorage.getItem("smbToken");

    const apiUrl = bookingMode === "profile_login" ? loginApi : otpApi;
    const headers =
      bookingMode === "profile_login"
        ? {
            Authorization: `Bearer ${smbToken}`,
            "Content-Type": "application/json",
          }
        : {
            "Content-Type": "application/json",
          };

    try {
      const response = await axios.post(apiUrl, payload, { headers });

      if (response.status === 200 || response.status === 201) {
        setOpenProfileDialog(false);

        if (bookingMode === "otp") {
          setOpenOtpDialog(true); // ✅ OPEN OTP DIALOG MODAL HERE
        }

        await Swal.fire({
          icon: "success",
          title: "Appointment Booked!",
          text: "Your appointment has been successfully scheduled.",
          confirmButtonColor: "#01008B",
        });

        setForm({
          name: "",
          mobile: "",
          email: "",
          service: [],
          gender: "Male",
          date: "",
          hour: "",
          minute: "",
        });
        setDate(null);
        setTime(null);
        setErrors({});
      }
    } catch (error) {
      console.error("Error booking appointment:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Something went wrong while booking your appointment.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("");

    if (!enteredOtp || enteredOtp.length !== 4 || isNaN(enteredOtp)) {
      Swal.fire({
        icon: "error",
        title: "Invalid OTP",
        text: "Please enter a valid 4-digit OTP.",
      });
      return;
    }

    try {
      const response = await axios.post(
        "https://elegantprime.in/webapp/user/api/v1/Salon/ValidateCustomerAppointmentForAnonymousBuyer",
        {
          mobileNumber: form.mobile, // Make sure this is set correctly
          otp: enteredOtp,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const resData = response.data;

      if (
        response.status === 200 &&
        resData?.succeeded &&
        resData?.data?.appointmentId
      ) {
        setOpenOtpDialog(false); // Close modal

        Swal.fire({
          icon: "success",
          title: "OTP Verified",
          text: `Appointment confirmed for ${resData.data.customerName}`,
        });

        // You can access the returned data like this if needed:
        // const appointmentDetails = resData.data;
        // console.log(appointmentDetails);
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid OTP",
          text: "The OTP you entered is incorrect or verification failed.",
        });
      }
    } catch (error) {
      console.error("OTP validation error", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not verify OTP. Please try again.",
      });
    }
  };

  return (
    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/appoinment"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />
      <Box display={"flex"} alignItems={"center"} my={4}>
        <IconButton
          size="small"
          sx={{ mx: { xs: 2, sm: 6, md: 8, lg: 9 } }}
          // onClick={() => navigate(routePath.SERVICESLIST)}
        >
          <KeyboardBackspaceIcon
            sx={{ color: "#01008B", fontSize: { sm: "30px", xs: "20px" } }}
          />
        </IconButton>
        <Typography
          variant="h6"
          fontWeight={600}
          fontSize={{ lg: 30, md: 25, sm: 20, xs: 15 }}
        >
          Book New Appointment With
        </Typography>
      </Box>
      <Container>
        <Box display="flex" alignItems="center" gap={4}>
          {/* Profile Login */}
          <Box
            sx={{
              border: "3px solid #01008B",
              borderRadius: 3,
              width: 180,
              height: 200,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => handleOpenProfileDialog("profile_login")}
          >
            <img
              src={profile_login}
              alt="Profile Login"
              style={{ width: "100px", height: "100px" }}
            />
            <Typography
              color="#01008B"
              fontWeight={600}
              mt={2}
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "16px" },
              }}
            >
              Profile Login
            </Typography>
          </Box>

          {/* OR */}
          <Typography variant="h5" color="#01008B" fontWeight={600}>
            OR
          </Typography>

          {/* OTP Login */}
          <Box
            sx={{
              border: "3px solid #01008B",
              borderRadius: 3,
              width: 180,
              height: 200,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            // onClick={() => setOpenOtpDialog(true)}
            onClick={() => handleOpenProfileDialog("otp")}
          >
            <img
              src={otp_login}
              alt="OTP Verification"
              style={{ width: "100px", height: "100px" }}
            />
            <Typography
              color="#01008B"
              fontWeight={600}
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "16px" },
              }}
              mt={2}
            >
              OTP Verification
            </Typography>
          </Box>
        </Box>

        {/* Profile Login Dialog */}
        <Dialog
          open={openProfileDialog}
          onClose={() => setOpenProfileDialog(false)}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle
            sx={{ textAlign: "center", fontWeight: 600, color: "#01008B" }}
          >
            {bookingMode === "profile_login"
              ? "Add Appointment"
              : "Add Appointment"}
            <IconButton
              onClick={() => setOpenProfileDialog(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "#01008B",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <Box display="flex" flexDirection="column" gap={2} mt={1}>
              <TextField
                label={
                  <span>
                    Full Name: <span style={{ color: "red" }}>*</span>
                  </span>
                }
                size="small"
                fullWidth
                value={form.name}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleChange("name")(e);
                  }
                }}
                error={!!errors.name}
                helperText={errors.name}
              />

              <TextField
                label={
                  <span>
                    Mobile Number: <span style={{ color: "red" }}>*</span>
                  </span>
                }
                size="small"
                fullWidth
                value={form.mobile}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    handleChange("mobile")(e);
                  }
                }}
                inputProps={{ maxLength: 10 }}
                error={!!errors.mobile}
                helperText={errors.mobile}
              />

              <TextField
                label="Email Id"
                size="small"
                fullWidth
                value={form.email}
                onChange={handleChange("email")}
              />

              <FormControl fullWidth error={!!errors.service}>
                {/* <InputLabel id="service-label">Select Services *</InputLabel> */}
                <Select
                  labelId="service-label"
                  multiple
                  required
                  size="small"
                  value={form.service}
                  onChange={handleServiceChange}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return (
                        <span>
                          Select Services:{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      );
                    }
                    return selected
                      .map((item) => item.itemDescription)
                      .join(", ");
                  }}
                  displayEmpty
                  inputProps={{ "aria-label": "Select Services" }}
                >
                  {servicesArr.map((service) => (
                    <MenuItem key={service.id} value={service}>
                      <ListItemText primary={service.itemDescription} />
                      <Checkbox
                        checked={form.service.some((s) => s.id === service.id)}
                        sx={{ ml: "auto" }}
                      />
                    </MenuItem>
                  ))}
                </Select>
                {errors.service && (
                  <FormHelperText>{errors.service}</FormHelperText>
                )}
              </FormControl>

              <Box>
                <Typography fontWeight={600} mb={1}>
                  Gender
                </Typography>
                <RadioGroup
                  row
                  value={form.gender}
                  onChange={handleChange("gender")}
                >
                  <FormControlLabel
                    value="Male"
                    control={<Radio />}
                    label="Male"
                  />
                  <FormControlLabel
                    value="Female"
                    control={<Radio />}
                    label="Female"
                  />
                  <FormControlLabel
                    value="Other"
                    control={<Radio />}
                    label="Other"
                  />
                </RadioGroup>
              </Box>

              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <DatePicker
                      label={
                        <span>
                          Date: <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      value={date}
                      onChange={setDate}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: !!errors.date,
                          helperText: errors.date,
                          sx: {
                            "& .MuiInputBase-root": {
                              height: 40,
                            },
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl fullWidth error={!!errors.time}>
                      <TextField
                        fullWidth
                        readOnly
                        label={
                          <span>
                            Time: <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        value={
                          form?.hour !== undefined && form?.minute !== undefined
                            ? formatTimeTo12Hour(form?.hour, form?.minute)
                            : ""
                        }
                        error={!!errors.time}
                        helperText={errors.time}
                        InputProps={{
                          sx: { height: 40 },
                          endAdornment: (
                            <AccessTimeIcon
                              onClick={() => setOpenTt(true)}
                              sx={{
                                color: (theme) => theme.palette.primary.main,
                                cursor: "pointer",
                              }}
                            />
                          ),
                        }}
                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </LocalizationProvider>

              <Button
                variant="contained"
                fullWidth
                sx={{
                  mt: 2,
                  backgroundColor: "#01008B",
                  textTransform: "none",
                  fontWeight: 500,
                  borderRadius: 1,
                  py: 1,
                  fontSize: 16,
                }}
                onClick={handleSubmit}
              >
                Book an Appointment
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        {/* OTP Login Dialog */}
        <Dialog
          open={openOtpDialog}
          onClose={() => setOpenOtpDialog(false)}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            sx: {
              borderRadius: 3,
              px: 4,
              py: 3,
            },
          }}
        >
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 600,
              fontSize: "1.8rem",
              color: "#01008B",
            }}
          >
            OTP VERIFICATION
          </DialogTitle>

          <DialogContent>
            <Box mt={1}>
              <Typography
                variant="subtitle1"
                sx={{ color: "#01008B", mb: 1, fontSize: 16, fontWeight: 500 }}
              >
                Enter OTP
              </Typography>

              {/* OTP Inputs */}
              <Box display="flex" justifyContent="center" gap={3} mb={5}>
                {[1, 2, 3, 4].map((_, i) => (
                  <TextField
                    key={i}
                    value={otp[i]}
                    onChange={(e) => {
                      const value = e.target.value.slice(0, 1);
                      const newOtp = [...otp];
                      newOtp[i] = value;
                      setOtp(newOtp);
                      // Move to next field automatically
                      if (value && i < 3) {
                        const nextInput = document.getElementById(
                          `otp-${i + 1}`
                        );
                        if (nextInput) nextInput.focus();
                      }
                    }}
                    id={`otp-${i}`}
                    variant="standard"
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: "center",
                        fontSize: "1.2rem",
                        fontWeight: 600,
                        width: "70px",
                      },
                    }}
                    sx={{
                      "& .MuiInput-underline:before": {
                        borderBottomWidth: "3px",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomWidth: "3px",
                      },
                    }}
                  />
                ))}
              </Box>

              {/* Continue Button */}
              <Button
                onClick={handleVerifyOtp}
                variant="contained"
                fullWidth
                sx={{
                  backgroundColor: "#01008B",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "1rem",
                  borderRadius: 1,
                  py: 1,
                  mb: 2,
                }}
              >
                Continue
              </Button>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "#01008B", textAlign: "center", fontSize: 20 }}
                >
                  OTP Not Received?
                </Typography>
                <Button
                  variant="text"
                  sx={{
                    color: "#01008B",
                    fontWeight: 600,
                    textTransform: "none",
                    fontSize: "1rem",
                    mt: -1,
                    textAlign: "center",
                    fontSize: 20,
                  }}
                >
                  Resend
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        <TimeModal
          open={openTt}
          data={form}
          setOpen={setOpenTt}
          date={(tt) => {
            setForm((prev) => {
              let tempP = { ...prev };
              if (tt?.noon == "PM") {
                tempP.hour = tt?.hour + 12;
                tempP.minute = parseInt(tt?.min);
                tempP["noon"] = "PM";
              } else {
                tempP.hour = tt?.hour;
                tempP.minute = parseInt(tt?.min);
                tempP["noon"] = "AM";
              }
              return { ...tempP };
            });
            setOpenTt(false);
          }}
        />
      </Container>
    </>
  );
};

export default Appoinment;
